import { createSelector } from 'reselect';
import { UserState } from './redux';
import { AppState } from '../reducers';

export const getUserState = (state: AppState) => state.currentUser;

export const getUserProfile = createSelector([getUserState], (userState: UserState) => {
	return userState ? userState.user : null;
});
